<template>
  <div>
    <div 
      id="modal-caracteristicas-produto"
      class="w3-animate-zoom w3-modal"
      v-if="abrir_modal_caracteristicas_produto" 
      style="display: block; z-index:110!important; padding:0px!important;">
      
      <div class="w3-modal-content w3-animate-zoom" @click.stop>
        <header class="w3-container">
          <span 
            @click="abrir_modal_caracteristicas_produto = false" 
            class="w3-button w3-display-topright">&times;
          </span>
          
          <h4 class="texto-vermelho w3-center">Características do produto</h4>
          
          <h3 class="texto-cinza w3-center" v-if="dados_produto.produto_id != undefined">
            {{formatarValor(dados_produto.produto_id, 0)}} - {{dados_produto.nome}}
          </h3>
        </header>
        
        <div class="w3-row-padding">
          <div class="w3-col s12 m3">
            <img 
              v-if="produto_caracteristicas.foto_produto!=undefined" 
              :src="`data:image/JPEG;base64,${produto_caracteristicas.foto_produto}`" 
              style="max-width: 150px" 
              class="w3-round" 
              alt="Foto do produto"
            />
          </div>
        
          <div 
            class="w3-col s12 m9" style="font-family: roboto"
            v-if="produto_caracteristicas.caracteristicas_produto != undefined && produto_caracteristicas.caracteristicas_produto.length > 0">
            <pre 
              class="texto-preto">
              {{produto_caracteristicas.caracteristicas_produto}}
            </pre>
          </div>

          <div class="w3-col s12 m9" v-else>
            Não há características cadastradas.
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import VueNumeric from 'vue-numeric'
import formatarValorMixin from '@/mixins/formatarValorMixin'
import moment from 'moment'
import Legenda from '@/components/Legendas' 
import Biblioteca from '@/components/Repositorio/Biblioteca.js'
import RProdutoBuscarProdutoCaracteristicas from '@/components/Rest/RProduto/RProdutoBuscarProdutoCaracteristicas.js'

export default {
  name: 'ModalCaracteristicasProduto',
  props: {},
  components: {VueNumeric, Legenda},
  mixins:[formatarValorMixin],
  data () {
    return {
      api: process.env.API,
      dados_produto: {},
      produto_caracteristicas: {},
      abrir_modal_caracteristicas_produto: false,
    }
  },

  methods: {
    exibirModal(produto){
      this.dados_produto = Object.assign({}, produto);
      this.buscarProdutoCaracteristicas();
    },

    async buscarProdutoCaracteristicas(){
      try {
        this.produto_caracteristicas = {};
        
        let parametros = {
          produto_id: this.dados_produto.produto_id
        }

        let retorno = await RProdutoBuscarProdutoCaracteristicas.buscarProdutoCaracteristicas(this.axios, parametros);
        
        if (retorno.houve_erro == 'S'){
          throw new Error(retorno.mensagem);
        }
        
        this.produto_caracteristicas = retorno.dados;
        this.abrir_modal_caracteristicas_produto = true;
      } catch (error) {
        this.verificarErro(error, 'buscarProdutoCaracteristicas');
      }
    }, 
    
    verificarErro(erro, nome_funcao){
      Biblioteca.gerarLogNomeFuncao('ModalCaracteristicasProduto.vue -> ' + nome_funcao);
      let mensagem = Biblioteca.tratamentoMensagem(erro);
      Biblioteca.exclamar(mensagem);
    },
  },
}
</script>

<style scoped>

  .tela-cheia{
    width: 100%!important;
    height: 100%!important;
    padding-top: 0%!important;
    padding-left: 0%!important;
  }

</style>


// WEBPACK FOOTER //
// src/components/Orcamentos/ModalCaracteristicasProduto.vue